import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import kebabCase from 'lodash.kebabcase';

// Translation provided by Vuetify
import { ar, en, es } from 'vuetify/lib/locale';
import az from '@/translations/vuetify/az';

const icons = {};

try {
  require.context('@/components/Icons/', false, /^.*\.vue$/).keys().forEach(fileName => {
    fileName = fileName.replace('./', '');
    const icon = require(`@/components/Icons/${fileName}`).default;
    fileName = kebabCase(fileName.replace('.vue', ''));

    if (fileName === 'arrow') {
      icons['arrow-right'] = { component: icon };
      icons['arrow-left'] = { component: icon, props: { direction: 'left' } };
      icons['arrow-up'] = { component: icon, props: { direction: 'up' } };
      icons['arrow-down'] = { component: icon, props: { direction: 'down' } };
    } else if (fileName === 'arrow-line') {
      icons['arrow-line-right'] = { component: icon };
      icons['arrow-line-left'] = { component: icon, props: { direction: 'left' } };
      icons['arrow-line-up'] = { component: icon, props: { direction: 'up' } };
      icons['arrow-line-down'] = { component: icon, props: { direction: 'down' } };
    } else if (fileName === 'arrow-filled') {
      icons['arrow-filled-right'] = { component: icon, props: { direction: 'right' } };
      icons['arrow-filled-left'] = { component: icon, props: { direction: 'left' } };
      icons['arrow-filled-up'] = { component: icon, props: { direction: 'up' } };
      icons['arrow-filled-down'] = { component: icon };
    } else if (fileName === 'dots') {
      icons['dots-vertical'] = { component: icon };
      icons['dots-horizontal'] = { component: icon, props: { direction: 'horizontal' } };
    } else icons[fileName] = { component: icon };
  });
// eslint-disable-next-line no-empty
} catch {}

Vue.use(Vuetify);
export default new Vuetify({
  lang: {
    locales: { ar, en, es, az },
    current: 'en',
  },
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 601,
      sm: 961,
      md: 1280,
      lg: 1920,
    },
  },
  icons: {
    values: icons,
  },
  theme: {
    themes: {
      light: {
        primary: '#18A6D7',
        success: '#1CD17B',
        secondary: '#1CD17B',
        error: '#E93E3E',
        green: '#4DBB6C',
        warning: '#F0A54D',
        'primary-light': '#C9F2FC',
        'grey-dark': '#7E8490',
        'grey-darken': '#2e3343',
        'grey-light': '#b6b7c1',
        'grey-light1': '#EBEFF4',
        'grey-light2': '#F1F3F6',
        'background-light': '#F5F9FE',
        'background-lighten': '#F7F8FC',
        'box-sh': '#ECEEF5',
      },
    },
  },
});
